import styles from "./AiIcon.module.css";

export function AiIcon({ className, onClick }: { className?: string; onClick?: () => void }) {
  return (
    <div className={`${styles.aiIcon} ${className}`} onClick={onClick}>
      <span className={`narmi-icon-sparkle ${styles.aiIcon}`} />
    </div>
  );
}
